function getSWCoordinates(coordinates: number[][]): number[] {
    const lowestLng = Math.min(
        ...coordinates.map((coordinates) => coordinates[0])
    );
    const lowestLat = Math.min(
        ...coordinates.map((coordinates) => coordinates[1])
    );

    return [lowestLng, lowestLat];
}

function getNECoordinates(coordinates: number[][]) {
    const highestLng = Math.max(
        ...coordinates.map((coordinates) => coordinates[0])
    );
    const highestLat = Math.max(
        ...coordinates.map((coordinates) => coordinates[1])
    );

    return [highestLng, highestLat];
}

export function boundingBoxFrom(coordinates: number[][]): number[][] {
    return [
        getSWCoordinates(coordinates),
        getNECoordinates(coordinates),
    ];
}